<template>
  <View direction="column" gap="sm">
    <View justify="space-between" align="center" gap="sm">
      <button type="button" class="toggle" :aria-expanded="expanded" @click="expanded = !expanded">
        <Text variant="label-medium" as="span">Highlights</Text>
        <Icon name="chevron-down" size="extra-small" :class="{ rotated: expanded }" />
      </button>

      <Badge v-if="isActionable" label="Actionable" variant="orange" size="small" />
    </View>

    <View v-if="expanded" direction="column" gap="md" class="items">
      <Text v-if="!items.length" variant="body-small" color="tertiary">No highlights were extracted.</Text>

      <View v-for="(item, index) in items" :key="index" direction="column" gap="xs" class="item">
        <Text v-if="item.details" variant="body-medium">{{ item.details }}</Text>
        <Text variant="body-small" color="secondary">{{ metaLine(item) }}</Text>
      </View>
    </View>
  </View>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Badge, Icon, Text, View } from '@tallo/design-system';

interface HighlightItem {
  category: string;
  details: string | null;
  type: string;
  isActionable: boolean;
  priority: string;
}

defineProps<{ items: HighlightItem[]; isActionable: boolean }>();

const expanded = ref(false);

// e.g. "Category: Property condition • Positive • Low • Not actionable"
function metaLine(item: HighlightItem): string {
  const parts = [item.type, item.priority, item.isActionable ? 'Actionable' : 'Not actionable'].filter(Boolean);
  return `Category: ${[item.category, ...parts].join(' • ')}`;
}
</script>

<style scoped lang="scss">
.toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--t-spacing-xs);
  padding: 0;
  background: none;
  border: none;
  color: var(--t-text-color-primary);
  cursor: pointer;
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.items {
  padding-top: var(--t-spacing-xs);
}
</style>
